(ns renolit-roofing-service.util.localization
  (:require [renolit-roofing-service.localization :refer [t]]))


(defn dropdown-value
  [label-transl-kw v]
  (t [(keyword (str "domain.choices." (name label-transl-kw) "." (name v)))]))
